// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d12c5173","455":"6daa7734","541":"dbab89cb"}[chunkId] + ".chunk.js";
};